export default function Style(){
  return (
    <style>
      {`
       @media screen and (min-width: 1543px) {
  .fs-res-24 {
    font-size: 24px !important;
    line-height: 30px !important;
    font-weight: 400 !important;

  }

  .fs-res-18 {
    font-size: 18px !important;
    line-height: 18px !important;
    font-weight: 400 !important;

  }

  .fs-res-24-18 {
    font-size: 18px !important;
    line-height: 27px !important;
  }

}

@media screen and (max-width: 1534px) {
  .fs-res-24 {
    font-size: 22px !important;
    line-height: 28px !important;
    font-weight: 400 !important;

  }

  .fs-res-18 {
    font-size: 16px !important;
    line-height: 16px !important;
    font-weight: 400 !important;
  }

  .fs-res-24-18 {
    font-size: 16px !important;
    line-height: 24px !important;
  }

}

@media screen and (max-width: 500px) and (min-width: 450px) {
  .px-mobile-explore {
    padding-left: 13%;
    padding-right: 13%;
  }
    .px-mobile-explore-img {
      height: 324px !important;
    }
  
}

/* // @media screen and (max-width: 1400px) and (min-width : 1280px)  {
//   .px-mobile-explore
// }

// .modal_custom{
//   // top: 12% !important;
//   background-color: rgba(0, 0, 0, 0.8);
//   overflow: hidden;
  
// }
// .modal-dialog{
//   margin: 3.5 auto !important;
// }
// @media screen and (max-width: 768px) {
//   .modal-dialog {
//     max-width: 75% !important;
//   }

// }
// @media screen and (min-width: 768px) {
//   .modal-dialog {
//     max-width: 60% !important;
//   }

// }
// @media screen and (min-width: 1024px) {
//   .modal-dialog{
//     max-width: 50%!important; 
//   }
  
// }
// @media screen and (min-width: 1200px) {
//   .modal-dialog{
//     max-width: 40%!important; 
//   }
  
// }
// @media screen and (min-width: 1400px) {
//   .modal-dialog {
//     max-width: 40% !important;
//   }

// }
// @media screen and (min-width: 1700px) {
//   .modal-dialog {
//     max-width: 35% !important;
//   }

// }
// @media screen and (min-width: 1860px) {
//   .modal-dialog {
//     max-width: 30vw !important;
//   }

// }
// @media screen and (min-width: 1024px) {
//   .modal-dialog {
//     max-width: 500px !important;
//   }

// }
// @media screen and (min-width: 1280px) {
//   .modal-dialog {
//     max-width: 600px !important;
//   }

// }
// @media screen and (min-width: 1534px) {
//   .modal-dialog {
//     max-width: 750px !important;
//   }

// } */
        `}
    </style>
  );
}
